<script>
import { setCookie, getCookie } from '../../../plugins/cookies';

export default {
  name: 'SavePresetButton',
  data() {
    return {
      hasSeenNewFeature: false,
    };
  },
  beforeMount() {
    this.hasSeenNewFeature = getCookie('hasSeenNewFeature');
  },
  methods: {
    closeNewFeatureIndicator() {
      this.hasSeenNewFeature = true;
      const EXPIRES_IN_TWO_DAYS = 60 * 60 * 24 * 2;
      const cookieValue = true;
      setCookie({ name: 'hasSeenNewFeature', value: cookieValue, secure: false, duration: EXPIRES_IN_TWO_DAYS });
    },
    handleSavePreset() {
      this.$store.commit('Predictor/SET_MODAL_STATUS', { showModal: true });
    },
  },
};
</script>


<template>
  <div class="predictor-save-preset-wrap">
    <div v-if="!hasSeenNewFeature" class="predictor-footer__new-feature-indicator">
      <div class="new-feature-indicator__main new-feature-indicator-text">
        <strong>new</strong>
        <div>Save Presets to easily apply next time</div>
      </div>
      <img
        class="predictor-footer__close-btn"
        src="//puntcdn.com/predictor/close-filled.svg"
        @click.prevent="closeNewFeatureIndicator"
      >
    </div>
    <div class="predictor-save-preset__primary">
      <button class="predictor-save-preset" @click="handleSavePreset">
        <div class="predictor-save-preset-inner">
          <img src="//puntcdn.com/predictor/save.svg" class="predictor-footer__save-icon" >
          save filters
        </div>
      </button>
    </div>
  </div>
</template>
